import React, { useContext, useState } from 'react';

import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

import FireDataContext from '../../../services/firebase/FireDataContext';

const ArchiveItemButton = ({ doc, docType }) => {
    const db = useContext(FireDataContext);
    const [path] = useState(doc._docPath);
    const [archived, setArchived] = useState(Boolean(doc.archived));

    const handleClick = () => {
        const updated = !archived;
        db.update({ path, payload: { archived: updated }})
            .then(() => {
                setArchived(updated);
                console.log('archived', updated, path);
            })
            .catch(console.log);
    }

    const action = archived ? 'Unarchive' : 'Archive';

    return (
        <Tooltip title={`${action} this ${docType}`}>
            <IconButton onClick={handleClick} size="small" color={archived ? "default" : "secondary"} aria-label={`${action} ${docType}`} >
                <VisibilityOffIcon />
            </IconButton>
        </Tooltip>
    );
};

export default ArchiveItemButton;